module.exports = __webpack_public_path__ + "static/media/24_negro.c27737aa.svg";